import { StorageKeys } from "@/common/constants/storageKeys";
import { Lockr } from "@/common/Lockr";
import { ServerEvent } from "@/common/notification";
import { AgentActions, useAgentStore } from "@/common/stores/persistingStores/agentPermissions";
import { useAuth } from "@/hooks/authentication";
import { notificationListener } from "@/hooks/notification";
import { InternalPresenceDto } from "@/repository/models";
import { getCurrentPresence } from "@/repository/queryFns";
import { useEffect } from "react";

export const usePresenceManager = () => {
	const authContext = useAuth();
	const currentAgentActions = useAgentStore((actions: AgentActions) => actions);

	useEffect(() => {
		if (!authContext.isLogged) {
			return;
		}

		getCurrentPresence().then((result) => {
			if (result.availability) {
				currentAgentActions.setPresence(result.availability, result.activity);
				currentAgentActions.setStatusTimer(result.updatedAt);
			}
		});
	}, [authContext.isLogged]);

	notificationListener(
		ServerEvent.InternalPresenceChanged,
		(internalPresenceDto: InternalPresenceDto) => {
			if (internalPresenceDto.presence.id == Lockr.get(StorageKeys.UserId)) {
				currentAgentActions.setStatusTimer(
					internalPresenceDto.presence.updatedAt
				);
			}
		}
	);
};
